import { useEntityUpdateMutation } from 'app/agriculture/mutations/entity/update/useEntityUpdateMutation';
import { AgricultureToastType } from 'app/agriculture/AgricultureToast/agriculture_toast_service';
import { Dialog } from 'app/agriculture/components/Dialog/Dialog';
import { IconSeparatedColumns } from 'app/agriculture/components/IconSeparatedColumns/IconSeparatedColumns';
import { LinkIcon } from 'app/agriculture/icons';
import { StatDisplay } from 'app/agriculture/components/StatDisplay/StatDisplay';
import { Button } from 'app/agriculture/components/Button/Button';
import { Tank } from 'app/agriculture/queries/tanks/types/Tank';
import { Device } from 'app/agriculture/queries/devices/types/Device';
import { useContext } from 'react';
import { ServicesContext } from 'app/items/shared/context_interface';
import { useNavigate } from 'react-router-dom';
import { brandConfig } from 'app/agriculture/queries/snapshots/config/brandConfig';
import { ContentLayout } from 'app/agriculture/components/ContentLayout/ContentLayout';

interface TankUnlinkFormProps {
    tank: Tank;
    device: Device;
    entityRootPath: 'tanks' | 'devices';
}

export function TankUnlinkForm({ tank, device, entityRootPath }: TankUnlinkFormProps) {
    const { agricultureToastService } = useContext(ServicesContext);
    const navigate = useNavigate();
    const deviceType = brandConfig[device.brand].parentType;
    const deviceMutation = useEntityUpdateMutation(deviceType);

    function handleSubmit() {
        deviceMutation.mutate(
            {
                id: device.id,
                infrastructureId: null,
            },
            {
                onSuccess: () => {
                    void agricultureToastService.showToast({
                        title: 'Device Unlinked',
                        type: AgricultureToastType.SUCCESS,
                        variant: 'simple',
                    });
                    navigate('..', { relative: 'path' });
                },
            },
        );
    }

    return (
        <Dialog
            title="Unlink Device"
            subtitle="Please confirm that you wish to unlink this device"
            className="TankLink"
            handleClose={() => {
                navigate('..', { relative: 'path' });
            }}
        >
            <ContentLayout gap={64}>
                <IconSeparatedColumns flip={entityRootPath === 'devices'} Icon={LinkIcon}>
                    <StatDisplay name="Water Tank" value={tank.name} />
                    <StatDisplay name="Device" value={device.name} />
                </IconSeparatedColumns>
                <Button
                    id="tank-unlink-submit"
                    text="Confirm Unlink"
                    fullWidth
                    onClick={() => {
                        handleSubmit();
                    }}
                />
            </ContentLayout>
        </Dialog>
    );
}
